/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';
import { IDeviceHealth } from '../state/device-health.state';

export const enum EDeviceHealthAction {
  GetSelectedDeviceHealthStatus = '[Device Health] Get Selected devices Health status',
  GetAllDeviceHealthStatusSuccess = '[Device Health] Get All devices Health status Success',
  GetSelectedDeviceHealthStatusError = '[Device Health] Get Selected devices Health status Failed',
  SelectVehicleIdForDeviceHealth = '[Device Health] Update Selected Vehicle id',
  SelectVehicleIdForDeviceHealthSuccess = '[Device Health] Update Selected Vehicle id Success',
  MapBalloonOpenWithDeviceHealthIssue = '[Device Health] Map balloon Opened with device health issue',
  GetSelectedDeviceHealthStatusSuccess = '[Device Health] Get Selected Device Health Status Success',
  GetCountOfAllDeviceIssuesError = '[Device Health] Get Count Of All Device Issues Error'
}

export class GetSelectedDeviceHealthStatusSuccess implements Action {
  public readonly type = EDeviceHealthAction.GetSelectedDeviceHealthStatusSuccess;
  constructor(public devicesHealth: IDeviceHealth[]) {}
}
export class GetCountOfAllDeviceIssuesError implements Action {
  public readonly type = EDeviceHealthAction.GetCountOfAllDeviceIssuesError;

  constructor(public error: any) {}
}
export class GetSelectedDeviceHealthStatus implements Action {
  public readonly type = EDeviceHealthAction.GetSelectedDeviceHealthStatus;
}

export class GetSelectedDeviceHealthStatusError implements Action {
  public readonly type = EDeviceHealthAction.GetSelectedDeviceHealthStatusError;

  constructor(public error: any) {}
}

export class GetAllDeviceHealthStatusSuccess implements Action {
  public readonly type = EDeviceHealthAction.GetAllDeviceHealthStatusSuccess;

  constructor(
    public devicesHealth: IDeviceHealth[],
    public countOfDevicesError: number
  ) {}
}

export class SelectVehicleIdForDeviceHealth implements Action {
  public readonly type = EDeviceHealthAction.SelectVehicleIdForDeviceHealth;
  constructor(public vehicleId: string) {}
}

export class SelectVehicleIdForDeviceHealthSuccess implements Action {
  public readonly type = EDeviceHealthAction.SelectVehicleIdForDeviceHealthSuccess;
  constructor(public vehicleId: string) {}
}

export class MapBalloonOpenWithDeviceHealthIssue implements Action {
  public readonly type = EDeviceHealthAction.MapBalloonOpenWithDeviceHealthIssue;
  constructor(public vehicleId: string) {}
}

export type DeviceHealthActions =
  | GetSelectedDeviceHealthStatus
  | GetSelectedDeviceHealthStatusError
  | GetAllDeviceHealthStatusSuccess
  | SelectVehicleIdForDeviceHealth
  | SelectVehicleIdForDeviceHealthSuccess
  | GetCountOfAllDeviceIssuesError
  | GetSelectedDeviceHealthStatusSuccess;
